// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1c-QW","imageUploader":"EGiftCard_imageUploader__V-GGm"};